// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tc-z","title":"Uc-z","cta":"Vc-z","disabled":"Wc-z"};